import React from 'react';

const MailCog: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M15.834 11.918C16.3863 11.918 16.834 12.3657 16.834 12.918V13.3633C17.0619
      13.4555 17.276 13.58 17.4717 13.7324L17.8594 13.5098C18.3376 13.2337 18.9494 13.3979
      19.2256 13.876C19.5017 14.3543 19.3377 14.966 18.8594 15.2422L18.4717 15.4658C18.4887
      15.5875 18.501 15.7107 18.501 15.835C18.5009 15.9587 18.4885 16.081 18.4717 16.2021L18.8604
      16.4268C19.3387 16.7027 19.5026 17.3146 19.2266 17.793C18.9504 18.2707 18.3394 18.4348
      17.8613 18.1592L17.4727 17.9346C17.2766 18.0874 17.0625 18.2124 16.834 18.3047V18.751C16.834
      19.3033 16.3863 19.751 15.834 19.751C15.2818 19.7508 14.834 19.3032 14.834 18.751V18.3047C14.6056
      18.2123 14.3913 18.0874 14.1953 17.9346L13.8086 18.1592C13.3304 18.4351 12.7185 18.2709
      12.4424 17.793C12.1664 17.3147 12.3304 16.7028 12.8086 16.4268L13.1963 16.2031C13.1793
      16.0817 13.168 15.959 13.168 15.835C13.168 15.7107 13.1793 15.5875 13.1963 15.4658L12.8086
      15.2422L12.7227 15.1865C12.3116 14.8901 12.1837 14.3244 12.4424 13.876C12.7011 13.4278 13.2546
      13.2556 13.7168 13.4629L13.8086 13.5098L14.1953 13.7334C14.3912 13.5806 14.6057 13.4557 14.834
      13.3633V12.918C14.834 12.3658 15.2818 11.9181 15.834 11.918ZM16.0967 3.18066C16.7072 3.24123
      17.2811 3.51157 17.7188 3.94922C18.1983 4.42883 18.4731 5.07231 18.4951 5.74805C18.4973 5.77379
      18.4988 5.79945 18.499 5.8252C18.499 5.82834 18.5 5.83181 18.5 5.83496V10.001C18.4998 10.5531
      18.0522 11.001 17.5 11.001C16.9479 11.0009 16.5002 10.5531 16.5 10.001V7.70215L10.5547
      11.666C10.2188 11.8899 9.78121 11.8899 9.44531 11.666L3.5 7.70215V14.168C3.50009 14.3447
      3.57036 14.5147 3.69531 14.6396C3.82029 14.7645 3.99035 14.8349 4.16699 14.835H10L10.1025
      14.8398C10.6067 14.8912 11 15.3173 11 15.835C10.9997 16.3523 10.6064 16.7778 10.1025 16.8291L10
      16.835H4.16699C3.45991 16.8349 2.7813 16.5536 2.28125 16.0537C1.78123 15.5537 1.50009 14.8751
      1.5 14.168V5.83496C1.5 5.83181 1.50097 5.82834 1.50098 5.8252C1.50119 5.79946 1.50267 5.77379
      1.50488 5.74805C1.52686 5.07236 1.80176 4.42882 2.28125 3.94922C2.78132 3.44915 3.45979 3.168
      4.16699 3.16797H15.833L16.0967 3.18066ZM15.835 15.168C15.6582 15.168 15.4883 15.2383 15.3633
      15.3633C15.2383 15.4883 15.168 15.6582 15.168 15.835C15.1681 16.0115 15.2385 16.1808 15.3633
      16.3057C15.4883 16.4305 15.6583 16.501 15.835 16.501C16.0115 16.5008 16.1808 16.4305 16.3057
      16.3057C16.4305 16.1808 16.5008 16.0115 16.501 15.835C16.501 15.6583 16.4305 15.4883 16.3057
      15.3633C16.1808 15.2385 16.0114 15.1682 15.835 15.168ZM4.16699 5.16797C3.99022 5.168 3.82031
      5.23828 3.69531 5.36328C3.68234 5.37626 3.67193 5.39137 3.66016 5.40527L10 9.63184L16.3389
      5.40527C16.3272 5.39154 16.3175 5.37611 16.3047 5.36328C16.2109 5.26947 16.0921 5.20626
      15.9639 5.18066L15.833 5.16797H4.16699Z`} fill="#98A2B3"/>
  </svg>
);

export default MailCog;
